import React, { useRef } from "react";

export default function ShimmerCard({ children, rarity = "default" , style}) {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * 20; // tilt sensitivity
    const rotateY = ((x - centerX) / centerX) * -20;

    card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    card.style.setProperty("--shimmer-x", `${(x / rect.width) * 100}%`);
  };

  const handleMouseEnter = () => {
    const card = cardRef.current;
    card.classList.add("shimmer-hover");
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    card.classList.remove("shimmer-hover");
    card.style.transform = `rotateX(0deg) rotateY(0deg)`;
    card.style.removeProperty("--shimmer-x");
  };

  return (
    <div className="card-wrapper" style={style} >
      <div
        ref={cardRef}
        className={`card ${rarity}`}
        onMouseMove={handleMouseMove}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
    </div>
  );
}
